
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AppComponent } from './app.component';

import { TokenComponent } from './components/token/token.component';
import { AuthenticationComponent } from './components/authentication/authentication.component';
import { SubmitbatchComponent } from './components/submitbatch/submitbatch.component';
import { WebsocketComponent } from './components/websocket/websocket.component';
import { JobdetailsComponent } from './components/jobdetails/jobdetails.component';
import { JobsettingsComponent } from './components/jobsettings/jobsettings.component';
import { ApilistComponent } from './components/apilist/apilist.component';
import { TokenandkeyComponent } from './components/tokenandkey/tokenandkey.component';
import { WebhookComponent } from './components/webhook/webhook.component';

import { OptimusComponent } from './components/optimus/optimus.component';
import { NewApiListComponent } from './components/new-api-list/new-api-list.component';
import { LiveBroadcastComponent } from './components/live-broadcast/live-broadcast.component';

const routes: Routes = [



  { path: "", component: HomeComponent },

  // getting Started

  { path: "tokenGeneration", component: TokenComponent },
  { path: "authentication", component: AuthenticationComponent },
  { path: "submitBatch", component: SubmitbatchComponent },
  { path: "websocket", component: WebsocketComponent },
  { path: "jobDetails", component: JobdetailsComponent },
  { path: "jobSettings", component: JobsettingsComponent },
  { path: "register", component: OptimusComponent },
  { path: "apilist", component: ApilistComponent },
  { path: "accessToken&secretKey", component: TokenandkeyComponent },
  { path: "webhook", component: WebhookComponent },
  { path: "live-broadcast", component: LiveBroadcastComponent },
  // { path: "new-apilist", component: NewApiListComponent },

  { path: 'apilist', loadChildren: () => import('./api-page/api-page.module').then(m => m.ApiPageModule) },



  { path: 'apilist', loadChildren: () => import('./new-api-list/new-api-list.module').then(m => m.NewApiListModule) },

  { path: 'solutions', loadChildren: () => import('./Solutions/solutions.module').then(m => m.SolutionsModule) },

  { path: "**", component: HomeComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
